import {extend, override} from 'flarum/common/extend';
import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import LinkButton from 'flarum/common/components/LinkButton';
import User from 'flarum/common/models/User';
import Form from './models/Form';
import {formulaireProfile} from './routes';

export default function () {
    extend(UserPage.prototype, 'navItems', function (this: UserPage, items) {
        const {user} = this;

        if (!user) {
            return;
        }

        const forms = user.formulaireForms();

        if (!forms) {
            return;
        }

        forms.forEach((form: Form) => {
            items.add('formulaire-' + form.id(), LinkButton.component({
                icon: 'fas fa-poll-h',
                href: formulaireProfile(user, form),
            }, form.title()));
        });
    });

    // We need to force a full user load in case the relationship has not already been loaded
    override(UserPage.prototype, 'loadUser', function (this: UserPage, original, username) {
        const lowercaseUsername = username.toLowerCase();

        if (app.store.all<User>('users').some((user) => {
            // Same logic that would cause this.show(user) to be called in the original method
            const wouldBeUsedInOriginal = (user.username().toLowerCase() === lowercaseUsername || user.id() === username) && user.joinTime();

            // If the model is in the store but the relationship is missing, we want to force a full user reload
            return wouldBeUsedInOriginal && !Array.isArray(user.formulaireForms());
        })) {
            // Same code that would have been called in the original method if the user was not found
            app.store.find<User>('users', username, {bySlug: true}).then(this.show.bind(this));
            return;
        }

        original(username);
    });
}
